define(() => {
    'use strict';

    /**
     * @namespace
     */
    return {
        STAGE_INITIAL: 'initial',
        STAGE_INDIVIDUAL: 'individual',
        STAGE_LEGAL: 'legal',
        STAGE_LEGAL_ADDRESS: 'legalAddress',
        STAGE_FINISH: 'finish',
    };
});
